<template>
  <div class="flex-start-md">
    <p>
      <span>
        <svg-icon-component icon="circle-exclamation" class="icon-sm danger" />
        <svg-icon-component icon="circle-triangle" class="icon-sm warning" />
      </span>
      <span class="mr-half">
        {{ t(`NotificationsComponent.${notification.type}`, { subscription: subscription }) }}
      </span>
    </p>
    <div class="btn-wrapper">
      <button class="btn-primary mr-quarter" target="_blank" @click="renewNow()">
        {{ t("NotificationsComponent.RenewNow") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import { t } from "@/i18n";
import { INotification } from "@/stores/notifications";
import SvgIconComponent from "@/components/shared/SvgIcon/SvgIcon.vue";
import { unifiedApi } from "@/common";
import { AxiosError } from "axios";
import { handleApiError } from "@/common/handleApiError";

const componentName = "AllstateExpiredNotification";

export default defineComponent({
  name: componentName,
  components: {
    SvgIconComponent,
  },
  props: {
    notification: {
      type: Object as PropType<INotification>,
      default: null,
    },
  },
  setup(props) {
    const subscription = ref<string>(props.notification?.params?.subscription ?? "");

    async function renewNow() {
      try {
        if (props.notification?.params?.keycode) {
          var url = (await unifiedApi.getWebrootRenewUrl(props.notification?.params?.keycode)).data.redirectUrl;
          window.open(url, "_blank");
        }
      } catch (err) {
        handleApiError(err as AxiosError, false);
      }
    }

    return { t, renewNow, subscription };
  },
});
</script>
